module.exports = __webpack_public_path__ + "static/media/TN-Women-Pants-v2.0.6c6818ab.svg";